import { render, staticRenderFns } from "./ProgramsAdmin.vue?vue&type=template&id=3ecf3051&scoped=true&"
import script from "./ProgramsAdmin.vue?vue&type=script&lang=js&"
export * from "./ProgramsAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProgramsAdmin.vue?vue&type=style&index=0&id=3ecf3051&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecf3051",
  null
  
)

export default component.exports